import { render, staticRenderFns } from "./text-field-date.vue?vue&type=template&id=40f3e6ff&scoped=true"
import script from "./text-field-date.vue?vue&type=script&lang=ts"
export * from "./text-field-date.vue?vue&type=script&lang=ts"
import style0 from "./text-field-date.vue?vue&type=style&index=0&id=40f3e6ff&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f3e6ff",
  null
  
)

export default component.exports